import { PropsWithChildren } from 'react';

import { Container, PAGE_CONTENT_WIDTH } from '@treams/treams-ui';

export default function LayoutSection({ children }: PropsWithChildren) {
	return <Container wide={PAGE_CONTENT_WIDTH}>{children}</Container>;
}
